/**
 * The users who I (@bcarper) trust with experimental features as a result of
 * demonstrated high attention to detail and knowledge of the entire product
 * and its feature's implications.
 */
const trustedAdminCheckoutOptimizationUsers = [
  "bcarper@getredo.com",
  "coleman@getredo.com",
  "cameron.walker@getredo.com",
  "aradford@getredo.com",
  "grant@getredo.com",
  "abby.woodward@getredo.com",
  "aubrey.matthias@getredo.com",
  "conti@redo.com",
  "ryan.conti@getredo.com",
];

export function isTrustedAdminCheckoutOptimizationUser(
  email: string | undefined,
): boolean {
  return !!email && trustedAdminCheckoutOptimizationUsers.includes(email);
}

const adminCheckoutOptimizationUsers = [
  ...trustedAdminCheckoutOptimizationUsers,
  "daisy@getredo.com",
  "cameron.buford@getredo.com",
  "brett.gunter@getredo.com",
  "braden@getredo.com",
  "dev@getredo.com",
];

export function isAdminCheckoutOptimizationUser(
  email: string | undefined,
): boolean {
  return !!email && adminCheckoutOptimizationUsers.includes(email);
}

export function isRedoUser(email: string | undefined): boolean {
  return !!email && email.endsWith("@getredo.com");
}

export function isStagecoachDeveloper(email: string | undefined): boolean {
  return email === "ryan.conti@getredo.com" || email === "dev@getredo.com";
}
